import React from 'react'
import { useWhatsAppStatus } from '../../contexts/WhatsAppStatusContext'

/**
 * Small amber pill shown on pages that display WhatsApp-sourced data
 * (Groups, WhatsApp Archive) when the integration is disconnected and we
 * are serving from the local cache instead of live OpenWA. Renders nothing
 * when connected.
 *
 * Pages decide where to place it — it has no internal layout assumptions.
 *
 * Usage:
 *   <CachedDataNote />
 */
export function CachedDataNote({ className = '' }: { className?: string }) {
  const status = useWhatsAppStatus()
  if (status.state !== 'disconnected') return null

  const when = status.last_synced_at
    ? new Date(status.last_synced_at).toLocaleString()
    : 'never'

  return (
    <div
      className={`inline-flex items-center gap-2 text-xs text-warning bg-warning-light border border-warning/20 rounded-full px-3 py-1 ${className}`}
      role="status"
      title={`Last refreshed ${when}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-warning animate-pulse" aria-hidden />
      <span>Showing cached data · last synced {when}</span>
    </div>
  )
}
